import React from 'react';
import { motion } from 'framer-motion';
import { Users, Linkedin, Mail } from 'lucide-react';

const Team = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 40 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const stagger = {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const teamMembers = [
    {
      name: 'Richard K.',
      role: 'Développeur Full-Stack & Fondateur',
      bio: "Co-fondateur de Kynovia Tech, Richard est un expert en développement full-stack. Il conçoit et pilote les solutions digitales avec une vision globale et orientée résultat.",
      image: './images/homme5.png',
      linkedin: 'https://linkedin.com/in/richardk',
      email: 'richard@kynoviatech.com',
    },
    {
      name: 'Priscille M.',
      role: 'Directrice Stratégie & Data & Co-Fondatrice',
      bio: "Data Analyst de formation, Priscille occupe le poste de Directrice Stratégie & Data . Elle allie rigueur analytique et vision business pour guider les décisions.",
      image: './images/femme1.png',
      linkedin: 'https://linkedin.com/in/priscillem',
      email: 'priscille@kynoviatech.com',
    },
    {
      name: 'Philemon. W.',
      role: 'Développeur Back-End & Co-Fondateur',
      bio: "Co-fondateur de Kynovia Tech, Philemon est spécialiste du développement back-end. Il assure la solidité, la sécurité et les performances de chaque solution déployée.",
      image: './images/homme4.png',
      linkedin: 'https://linkedin.com/in/phm',
      email: 'philemon@kynoviatech.com',
    },
    {
      name: "Rosette S.",
      role: "Experte Comptable",
      bio: "Rigoureuse et précise, Rosette assure la gestion comptable et financière de l’entreprise. Elle contrôle les budgets, élabore les bilans et conseille la direction sur la rentabilité et les choix fiscaux.",
      image: "/images/femme2.png",
      linkedin: 'https://linkedin.com/in/phm',
      email: 'philemon@kynoviatech.com',
    },
    {
      name: "Stella K.",
      role: "Cheffe de projet",
      bio: "Organisée et orientée résultats, Stella supervise la mise en œuvre des projets informatiques, de la conception à la livraison. Elle coordonne les équipes techniques, assure la communication avec les clients et veille au respect des délais et des standards de qualité.",
      image: "/images/femme4.png",
      linkedin: 'https://linkedin.com/in/phm',
      email: 'philemon@kynoviatech.com',
    },
    {
      name: "Amandine A.",
      role: "Responsable Marketing",
      bio: "Créative et connectée, Amandine développe la visibilité et l’image de marque de l’entreprise dans le secteur numérique. Elle élabore les stratégies de communication, gère les campagnes digitales et met en valeur les solutions informatiques proposées.",
      image: "/images/femme3.png",
      linkedin: 'https://linkedin.com/in/phm',
      email: 'philemon@kynoviatech.com',
    },
    {
      name: "Lisa P.",
      role: "Responsable relation client",
      bio: "Attentive et proactive, Lisa assure la coordination entre les clients et les équipes techniques. Elle identifie les besoins, accompagne la mise en œuvre des solutions informatiques et veille à la satisfaction de chaque partenaire.",
      image: "/images/femme5.png",
      linkedin: 'https://linkedin.com/in/phm',
      email: 'philemon@kynoviatech.com',
    },
    {
      name: "Jenovic M.",
      role: "Ingénieur système et réseau",
      bio: "Méthodique et passionné par les nouvelles technologies, Jenovic conçoit, administre et sécurise les infrastructures informatiques de l’entreprise et de ses clients. Il assure la performance des serveurs, la fiabilité du réseau et le bon fonctionnement des systèmes.",
      image: "/images/homme1.png",
      linkedin: 'https://linkedin.com/in/phm',
      email: 'philemon@kynoviatech.com',
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-cyan-50 to-blue-50 py-24 sm:py-32">
        <div className="absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] -z-10" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="initial"
            animate="animate"
            variants={stagger}
            className="text-center max-w-4xl mx-auto"
          >
            <motion.div variants={fadeInUp} className="inline-flex items-center space-x-2 bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-medium mb-8">
              <Users size={16} />
              <span>Notre équipe</span>
            </motion.div>
            <motion.h1
              variants={fadeInUp}
              className="text-5xl sm:text-6xl font-bold text-gray-900 mb-6 leading-tight"
            >
              Rencontrez notre équipe
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-gray-600 leading-relaxed"
            >
              Des experts passionnés par l'innovation et dévoués à votre succès. Ensemble, nous transformons vos idées en solutions technologiques performantes.
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={stagger}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                whileHover={{ y: -8 }}
                className="bg-white rounded-2xl border border-gray-200 hover:border-cyan-300 hover:shadow-2xl transition-all overflow-hidden group"
              >
                <div className="aspect-square overflow-hidden relative h-48">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
                  <p className="text-cyan-600 font-medium mb-4">{member.role}</p>
                  <p className="text-gray-600 leading-relaxed mb-6">{member.bio}</p>
                  <div className="flex space-x-3">
                   
                    
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Team;